import React, { useEffect } from 'react';
import { MainTable } from '../../Components/MainTable/MainTable';
import { useWarehouse } from './WarehouseStore';
import Add from './Add';
import Edit from './Edit';
import { Link } from 'react-router-dom';
import { Button, Tag } from 'antd';
import { EyeOutlined } from '@ant-design/icons';

function Warehouse() {
    const { warehouses, getWarehouse, getShops, deleteWarehouse, setEditRecord } = useWarehouse();

    useEffect(() => {
        getWarehouse();
        getShops();
    }, []);

    return (
        <MainTable
            pageTitle="Skladlar"
            pdata={warehouses}
            pcolumns={[
                { key: 'id', dataIndex: 'id', title: 'ID', width: 60 },
                { key: 'name', dataIndex: 'name', title: 'Nomi' },
                { key: 'location', dataIndex: 'location', title: 'Manzil' },
                {
                    key: 'shop', dataIndex: 'shop', title: "Do'kon",
                    render: (shop) => shop ? <Tag color="blue">{shop.shopname}</Tag> : <Tag>—</Tag>
                },
                {
                    key: 'details', title: 'Boshqaruv', width: 160, align: 'center',
                    render: (_, record) => (
                        <Link to={`/warehouse/${record.id}`}>
                            <Button type="primary" icon={<EyeOutlined />} size="small">
                                Boshqarish
                            </Button>
                        </Link>
                    )
                },
            ]}
            defkey="id"
            add={<Add />}
            onDelete={deleteWarehouse}
            onEdit={(rec) => setEditRecord(rec)}
            edit={<Edit />}
            setEd={() => {}}
        />
    );
}

export default Warehouse;